import React, {Fragment} from 'react';
import Error from '../../components/404/404'
import Scrollbar from '../../components/scrollbar/scrollbar'
import Navbar2 from '../../components/Navbar2/Navbar2';
import Logo from '../../images/logo2.png'
import Footer from '../../components/footer/Footer';

const ErrorPage =() => {
    return(
        <Fragment>
            <Navbar2 hclass={'wpo-header-style-2'} Logo={Logo} />
            {/* <PageTitle pageTitle={'404'} pagesub={'404'}/>  */}
            <Error/>
            <Footer/>
            <Scrollbar/>
        </Fragment>
    )
};
export default ErrorPage;

